const TOPICS = [
  { label: '狂飙大结局', hot: '980万讨论', icon: 'ri-fire-line' },
  { label: '三体视觉效果', hot: '650万讨论', icon: 'ri-rocket-line' },
  { label: '繁花沪语版', hot: '520万讨论', icon: 'ri-chat-3-line' },
  { label: '流浪地球2', hot: '890万讨论', icon: 'ri-planet-line' },
  { label: '鬼灭锻刀村', hot: '430万讨论', icon: 'ri-sword-line' },
  { label: '国产科幻崛起', hot: '760万讨论', icon: 'ri-star-line' },
  { label: '年度最佳剧集', hot: '310万讨论', icon: 'ri-award-line' },
  { label: '冷门高分推荐', hot: '280万讨论', icon: 'ri-lightbulb-line' },
  { label: '端午片单', hot: '190万讨论', icon: 'ri-calendar-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-2">全网影迷都在讨论的热门影视话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {TOPICS.map((topic) => (
            <a
              key={topic.label}
              href="#hero"
              className="inline-flex items-center gap-2 bg-background-100 hover:bg-background-200/70 border border-background-200/70 rounded-full px-4 py-2.5 transition-colors cursor-pointer group"
            >
              <i className={`${topic.icon} text-primary-500 text-sm`} />
              <span className="text-sm font-medium text-foreground-800">{topic.label}</span>
              <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded-full">
                {topic.hot}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}